import { DatePipe } from '@angular/common';
import moment from 'moment';
import { isWithinCalendarDateRange } from 'src/app/shared/utils/calendar-date.util';

export class DateRange {
  // Typed Date, but at runtime these hold whatever the API sent, which for date
  // columns is a UTC-encoded string.
  public startDate: Date;
  public endDate: Date;
  private datePipe: DatePipe = new DatePipe(moment.locale());

  constructor(_startDate: Date, _endDate: Date) {
    this.startDate = _startDate;
    this.endDate = _endDate;
  }

  hasAnyDates() {
    return this.startDate || this.endDate;
  }

  toString(format, timezone): string {
    if (!this.startDate && !this.endDate) {
      return '';
    }

    if (this.startDate && !this.endDate) {
      return `Start: ${this.datePipe.transform(this.startDate, format, timezone)}`;
    }

    if (!this.startDate && this.endDate) {
      return `End: ${this.datePipe.transform(this.endDate, format, timezone)}`;
    }

    return (
      (this.startDate ? this.datePipe.transform(this.startDate, format, timezone) : '') +
      this.getSeparator() +
      this.datePipe.transform(this.endDate, format, timezone)
    );
  }

  todayIsWithinDateRange() {
    return this.dateIsWithinRange(new Date());
  }

  private dateIsWithinRange(date: Date): boolean {
    return isWithinCalendarDateRange(this.startDate, this.endDate, date);
  }

  private getSeparator() {
    return this.startDate && this.endDate ? ' - ' : '';
  }
}
